"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteUserList = void 0;
var React = require("react");
var DataListTable_1 = require("../dataList/DataListTable");
var DataListState_1 = require("../dataList/DataListState");
var urls_1 = require("../../urls");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var SiteUsersInvite_1 = require("./SiteUsersInvite");
var RestData_1 = require("../../rest/RestData");
var SiteUserList = function (_a) {
    var project_id = _a.project_id, user = _a.user;
    var _b = __read(React.useState(new DataListState_1.DataListState(urls_1.Urls.logistics_users_list)), 1), data_list = _b[0];
    React.useEffect(function () {
        App_1.store.context.set(new contexts_1.ProjectContext(project_id));
        data_list.fetchData();
    }, [project_id, user]);
    function inviteNewUser(new_user_data) {
        $.ajax((0, urls_1.resolve)(urls_1.Urls.logistics_invite_user, project_id), {
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(new_user_data),
        })
            .then(function () { return data_list.fetchData(); })
            .fail(function (xhr, status, error) {
            return (0, RestData_1.process_failure)("", xhr, status, error);
        });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "row mt-2 mb-2" },
            React.createElement("div", { className: "col-8" },
                React.createElement("div", { className: "row mb-4" },
                    React.createElement("div", { className: "col" },
                        React.createElement("h3", null, gettext("Construction Site Users")))),
                React.createElement("div", { className: "row", style: {
                        height: "calc(100vh - 260px)",
                        overflowY: "auto",
                    } },
                    React.createElement("div", { className: "col" },
                        React.createElement(DataListTable_1.DataListTable, { html_id: "logisticsusers", bulk_update_param: "", data_list: data_list })))),
            React.createElement("div", { className: "col-4" },
                React.createElement("h3", null, gettext("Invite New User")),
                React.createElement(SiteUsersInvite_1.SiteUsersInvite, { inviteUser: inviteNewUser })))));
};
exports.SiteUserList = SiteUserList;
